import { render, staticRenderFns } from "./DelProDialog.vue?vue&type=template&id=2600910e&scoped=true"
import script from "./DelProDialog.vue?vue&type=script&lang=js"
export * from "./DelProDialog.vue?vue&type=script&lang=js"
import style0 from "./DelProDialog.vue?vue&type=style&index=0&id=2600910e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600910e",
  null
  
)

export default component.exports